import { ModuleTitle } from "@/components/patria/ModuleTitle";

export default function ModuleTitleRHYTHM({ className, tagline }) {
  return (
    <ModuleTitle
      className={className || "patria-module-title text-lg sm:text-xl"}
      testId="module-title-rhythm"
    >
      <span>RHYTHM</span>
      <span className="text-xs uppercase tracking-widest text-charcoal-muted">
        {tagline || "1:1 Tracking & Development"}
      </span>
    </ModuleTitle>
  );
}
